import { create } from 'zustand';

type AuthedWebviewUrlStore = {
  url?: string | null;
  setUrl: (url: string | null) => void;
};

/**
 * Store to manage the URL for authed webview links.
 * This is used to set the URL for the webview when a user clicks on an authed webview link.
 * The webview modal will then use this URL to load the content in an iframe and initiate the authentication flow.
 */
export const useAuthedWebviewUrlStore = create<AuthedWebviewUrlStore>(
  (set) => ({
    url: null,
    setUrl: (url) => set({ url }),
  }),
);
